import { querysProcessosInscritos } from "../../interfaces/processoSeletivo"
import baseApiGesttor from "../api"

export function listarProcessosSeletivos() {
  return baseApiGesttor.get("/listarProcessosSeletivos")
}

export function listarProcessoPorId(idVagaCript: string) {
  return baseApiGesttor.get(`/listarProcessoSeletivoPorIdHg/${idVagaCript}`)
}

export function inscreverProcessoSeletivo(idProcessoSeletivo: string) {
  return baseApiGesttor.post(`/processoInscrito/${idProcessoSeletivo}`)
}

export function listarProcessosInscritos(query: querysProcessosInscritos) {
  return baseApiGesttor.get(`/processoInscrito?nomeFantasia=${query.nomeFantasia}&situacao=${query.situacao}&cargo=${query.tituloCargo}`)
}